import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=7dd6d1ac&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=7dd6d1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd6d1ac",
  null
  
)

export default component.exports